var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderUploadedData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75.625C.766.625 0 1.418 0 2.375v8.75c0 .984.766 1.75 1.75 1.75h10.5c.957 0 1.75-.766 1.75-1.75v-7c0-.957-.793-1.75-1.75-1.75H7.902L6.754 1.227A1.971 1.971 0 0 0 5.359.625H1.75zm-.438 1.75a.45.45 0 0 1 .438-.438h3.61c.163 0 .327.083.464.192l1.23 1.258c.192.191.493.3.766.3h4.43a.47.47 0 0 1 .438.438v7a.45.45 0 0 1-.438.438H1.75a.432.432 0 0 1-.438-.438v-8.75zm6.344 7.656V7.242l.848.848a.599.599 0 0 0 .902 0c.274-.246.274-.656 0-.93L7.437 5.191a.644.644 0 0 0-.902 0l-1.969 1.97c-.273.273-.273.683 0 .929a.599.599 0 0 0 .903 0l.847-.848v2.79c0 .382.301.655.657.655a.632.632 0 0 0 .656-.656h.027z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderUploadedData);
export default __webpack_public_path__ + "static/media/folder-uploaded-data.8391895532d6fe1400817702a96fe0bd.svg";
export { ForwardRef as ReactComponent };